import template from './wageAdvance.html';
import controller from './wageAdvance.controller';
import './wageAdvance.scss';

let wageAdvanceComponent = {
  restrict: 'E',
  bindings: {
    serviceClosed: '<'
  },
  template,
  controller
};

export default wageAdvanceComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvance.component.js